document.addEventListener('DOMContentLoaded', function () {

    function numberWithCommas(x) {
      return x.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
    }

    function isTouchDevice() {
      return (('ontouchstart' in window) ||
         (navigator.maxTouchPoints > 0) ||
         (navigator.msMaxTouchPoints > 0));
    }

    var inputs = $('.calculator input:not(.total):not(.summary):not(.excluded)');
    var totalInputs = $('.calculator input.total');
    var totalGarmentQty = $('#total-garment-qty');
    var shippingToCustomer = $('#shipping-to-customer');

    const allTooltipContainers = document.querySelectorAll(".tooltip-container");
    allTooltipContainers.forEach((tooltipContainer)=>{
      tooltipContainer.addEventListener("mouseenter",function(){
        tooltipContainer.querySelector('.tooltip-container .tooltip').classList.remove('hidden');
      })
      tooltipContainer.addEventListener("mouseleave",function(){
        tooltipContainer.querySelector('.tooltip-container .tooltip').classList.add('hidden');
      })
    })

    $('.calculator input').on('keyup.total', function() {

        var emptyInputs = inputs.filter(function(index, element) {
            if (element.value == "" || element.value == "0" || element.value == "0.00" || element.value == "$" || element.value == "$0" || element.value == "$0.00" ) {
                return true;
            } else {
                return false;
            }
        });

        if (emptyInputs.length > 0) {
          totalInputs.val('');
        } else {

          var totalCostPerGarment = 0;
          var desiredProfitPerShirt;

          totalInputs.each(function () {
            var el = $(this);
            var group = el.data('total');
            var groupInputs = $('.calculator input:not(.total)[data-total="'+group+'"]');

            if (el.hasClass('divide-by-garment')) {
              var numericValue = Math.round( ((parseFloat(groupInputs[0].value.replace('$', '')) * (parseInt(groupInputs[1].value))) / parseInt(totalGarmentQty[0].value)) * Math.pow(10,2) ) / Math.pow(10,2);
              var newElValue = numericValue.toFixed(2);
              totalCostPerGarment = totalCostPerGarment + numericValue;
              el.val(`$${newElValue}`);
            } else if (el.hasClass('garment-shipping-cost')) {
              var numericValue = Math.round( ((parseFloat(groupInputs[0].value.replace('$', ''))) + (parseFloat(groupInputs[1].value.replace('$', '')) / parseInt(totalGarmentQty[0].value))) * Math.pow(10,2) ) / Math.pow(10,2);
              var newElValue = numericValue.toFixed(2);
              totalCostPerGarment = totalCostPerGarment + numericValue;
              el.val(`$${newElValue}`);
            } else if (el.hasClass('desired-profit')) {
              var newElValue = parseFloat(groupInputs[0].value.replace('$', ''))
              desiredProfitPerShirt = newElValue;
              totalCostPerGarment = totalCostPerGarment + newElValue;
              el.val(groupInputs[0].value);
            } else {
              var numericValue = Math.round( (parseFloat(groupInputs[0].value.replace('$', '')) * parseInt(groupInputs[1].value)) * Math.pow(10,2) ) / Math.pow(10,2);
              var newElValue = numericValue.toFixed(2)
              totalCostPerGarment = totalCostPerGarment + numericValue;
              el.val(`$${newElValue}`);
            }
          });

          $('#total-cost-per-garment').val(`$${totalCostPerGarment.toFixed(2)}`);
          $('#subtotal-order-cost').val(`$${numberWithCommas(parseFloat((Math.round( (parseInt(totalGarmentQty[0].value) * totalCostPerGarment) * Math.pow(10,2) )  / Math.pow(10,2)).toFixed(2)))}`);

          var totalOrderCost = (parseInt(totalGarmentQty[0].value) * totalCostPerGarment) + parseFloat(shippingToCustomer[0].value.replace('$', ''));
          $('#total-order-cost').val(`$${numberWithCommas(parseFloat(totalOrderCost.toFixed(2)))}`);
          $('#profit-from-order').val(`$${numberWithCommas(parseFloat((parseInt(totalGarmentQty[0].value) * desiredProfitPerShirt).toFixed(2)))}`)
        }
    });

    if (isTouchDevice()) {
      $("input[data-type='currency']").on({
        'keyup.currency': function() {
          formatCurrency($(this));
        },
        'mouseout': function() { 
          formatCurrency($(this), "blur");
        }
      });
    } else {
      $("input[data-type='currency']").on({
        'keyup.currency': function() {
          formatCurrency($(this));
        },
        'blur.currency': function() { 
          formatCurrency($(this), "blur");
        }
    });
    }

    $("input[data-type='currency']").on({
        'keyup.currency': function() {
          formatCurrency($(this));
        }
    });
    
    
    function formatNumber(n) {
      // format number 1000000 to 1,234,567
      return n.replace(/\D/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ",")
    }
    
    
    function formatCurrency(input, blur) {
      // appends $ to value, validates decimal side
      // and puts cursor back in right position.
      
      // get input value
      var input_val = input.val();
      
      // don't validate empty input
      if (input_val === "") { return; }
      
      // original length
      var original_len = input_val.length;
    
      // initial caret position 
      var caret_pos = input.prop("selectionStart");
        
      // check for decimal
      if (input_val.indexOf(".") >= 0) {
    
        // get position of first decimal
        // this prevents multiple decimals from
        // being entered
        var decimal_pos = input_val.indexOf(".");
    
        // split number by decimal point
        var left_side = input_val.substring(0, decimal_pos);
        var right_side = input_val.substring(decimal_pos);
    
        // add commas to left side of number
        left_side = formatNumber(left_side);
    
        // validate right side
        right_side = formatNumber(right_side);
        
        // On blur make sure 2 numbers after decimal
        if (blur === "blur") {
          right_side += "00";
        }
        
        // Limit decimal to only 2 digits
        right_side = right_side.substring(0, 2);
    
        // join number by .
        input_val = "$" + left_side + "." + right_side;
    
      } else {
        // no decimal entered
        // add commas to number
        // remove all non-digits
        input_val = formatNumber(input_val);
        input_val = "$" + input_val;
        
        // final formatting
        if (blur === "blur") {
          input_val += ".00";
        }
      }
      
      // send updated string to input
      input.val(input_val);
    
      // put caret back in the right position
      var updated_len = input_val.length;
      caret_pos = updated_len - original_len + caret_pos;
      input[0].setSelectionRange(caret_pos, caret_pos);
    }
}, false);